import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, AfterViewInit, ViewChild, Compiler, Injector, NgModule, NgModuleRef, TemplateRef, ViewContainerRef, ComponentFactoryResolver } from '@angular/core';
import { MenuService } from '../../../services/menu.service';
import { LogService } from '../../../services/log.service';
import { DashComponent } from '../../basic/dash/dash.component';
import { IdleComponent } from '../../basic/idle/idle.component';
import { ToastComponent } from '../../basic/toast/toast.component';
import { ContactInfoComponent } from '../../basic/contact-info/contact-info.component';
import { LockWidgetComponent } from '../../basic/lock-widget/lock-widget.component';
import { WaterpressureComponent } from '../../basic/waterpressure/waterpressure.component';
import { LoadinganimationComponent } from '../../basic/loadinganimation/loadinganimation.component';
import { MenuComponent } from '../../basic/menu/menu.component';
import { InlineMenuComponent } from '../../basic/inline-menu/inline-menu.component';
import { SettingsvalueComponent } from '../../basic/settingsvalue/settingsvalue.component';
import { environment } from '../../../../environments/environment';
import { DataIoService } from '../../../services/data-io.service';
import { BaseDisplayComponent } from '../../../widgets/basic/base-display/base-display.component';
import { ConfigService } from '../../../services/config.service';
import { CodeabfrageComponent } from '../../basic/fachhandwerker/codeabfrage/codeabfrage.component';
import { EnergiedatenComponent } from '../../basic/fachhandwerker/energiedaten/energiedaten.component';
import { ScaleListComponent } from '../../basic/scale-list/scale-list.component';
import { SetPhoneComponent } from '../../basic/set-phone/set-phone.component';
import { EcoComponent } from '../../basic/eco/eco.component';
import { TimesetComponent } from '../../basic/timeset/timeset.component';
import { SetupComponent } from '../../basic/setup/setup.component';
import { QuickvetoComponent } from '../../basic/quickveto/quickveto.component';
import { ZeitprogrammComponent } from '../../basic/zeitprogramm/zeitprogramm.component';


@Component({
	selector: 'app-screen',
	templateUrl: './screen.component.html',
	styleUrls: ['./screen.component.scss']
})
export class ScreenComponent implements OnInit {

	_debug:boolean=false;
	subscription :any=undefined;
	muted:boolean=false;
	@ViewChild('content',{ read: ViewContainerRef} ) content: ViewContainerRef;
	


	resolveComponent(screenType:string):any{
		console.warn("Resolving screenType: "+screenType);
		switch(screenType.toLowerCase()){
			case 'setup':{
				return SetupComponent;
			}
			case 'dashboard': {
				return DashComponent;
			}
			case 'codeabfrage':{
				return CodeabfrageComponent;
			}
			 case 'toast':{
			 	return ToastComponent;
			 }
			 case 'quickveto':{
			 	return QuickvetoComponent;
			 }
			 case 'energiedaten':{
			 	return EnergiedatenComponent;
			 }
			case 'idle':{
				return IdleComponent;
			}
			case 'timeset':{
				return TimesetComponent;
			}
			case 'zeitprogramm':{
				return ZeitprogrammComponent;
			}
			case 'waterpressure':{
				return WaterpressureComponent;
			}
			case 'eco':{
				return EcoComponent;
			}
			case 'settingsvalue':{
				return SettingsvalueComponent;
			}
			case 'setphone':{
				return SetPhoneComponent;
			}
			case 'contactinfo':{
				return ContactInfoComponent;
			}
			case 'scale-list':
			case 'scalelist':{
				return ScaleListComponent;
			}
			case 'inlinemenu':
			case 'inline-menu':{
				return InlineMenuComponent;
			}
			case 'menu':{
				return MenuComponent;
			}
			case 'loadinganimation':{
				return LoadinganimationComponent;
			}
			case 'lock_widget':{
				return LockWidgetComponent;
			}
			default: {
				return BaseDisplayComponent;
			}
		}
		return BaseDisplayComponent;
	}
	constructor(
		private log: LogService,
		private menuService: MenuService,
		private configService: ConfigService,
		private ioService: DataIoService,
		private vcr: ViewContainerRef,
		private cfr: ComponentFactoryResolver
	)
	{
		//this._debug = (!environment.production);
		this.debug("constructor()");
		
		this.subscription = this.ioService.inputs.events$.subscribe(
			(event)=>{
				if(event == 'language_changed'){
					this.reload();
				}
				this.eventHandler(event);
			}
		);
		/*
		if( this.configService.simulatorConfig.hasBattery() ){
			this.startDisplayTimeout();
			this.ioService.inputs.events$.subscribe(
				(event)=>{
					if(['up','down','menu','confirm','menu','question','panup','pandown','back'].includes(event)){
						this.resetDisplayTimeout();
					}
				}
			);
		}
		*/
	}	

	getScreenTemplate():string{
		return this.menuService.getCurrentNode().getScreenTemplate();
	}

	eventHandler(event){
		if(this.muted){
			return;
		}
		switch(event){
			case 'reinit_template_down':{
				this.debug("reinit template");
				this.showComponent('down');
				return;	
			}
			case 'reinit_template_up':{
				this.debug("reinit template");
				this.showComponent('up');
				return;	
			}
			case 'reinit_template':{
				this.debug("reinit template");
				this.showComponent();
				return;	
			}
			case 'menu':{
				/*
				let currentMenuIdentifier = this.menuService.getCurrentNode().getIdentifier();
				// controlshowcase
				if(currentMenuIdentifier.startsWith('controlshowcase')||currentMenuIdentifier.startsWith('wizard-controlshowcase')){
					return;
				}
				if(this.menuService.getCurrentNode().getButtons().includes('menu')){
					if(currentMenuIdentifier != "dashboard" && currentMenuIdentifier != 'blockingstate'){
						this.menuService.goto(this.menuService.findItem('dashboard'));
					}
					else{
						this.menuService.goto(this.menuService.findItem('mainmenu'));
					}
				}
				*/
				return;
			}

		}
	}

    _displayTimeoutHandle = null;
    _displayTimedout = false;
    _displayTimoutInterval = 30000;
    resetDisplayTimeout(){
    	this.clearDisplayTimeout();
    	this.startDisplayTimeout();
    }
    startDisplayTimeout(){
    	this._displayTimedout = false;
    	if(!this.configService.simulatorConfig.hasBattery()){
    		return;
    	}
        this._displayTimeoutHandle = setTimeout(()=>{
            this.onDisplayTimeout();
        }, this._displayTimoutInterval);
    }
    clearDisplayTimeout(){
    	if(this._displayTimeoutHandle != null){
        	clearTimeout(this._displayTimeoutHandle);
        	this._displayTimeoutHandle = null;
        }
    }
    onDisplayTimeout(){
        this._displayTimedout = true;   
        this.clearDisplayTimeout();
    }
    
    get brightness(){
		if(this.ioService.getDeviceInfo().getValue('powerstate') == 'off'){
			return '1';
		}
		if(this._displayTimedout){
			return '1';
		}
		let brightness =this.ioService.deviceInfo().getScale('brightness').getCurrentValue();
		return (0.05*(10.0-(brightness*1.0))).toString();
	}

	showComponent(direction? : "up"|"down"){

		let osr = this.content;
		if(!osr){
			this.debug("OnScreenRef was undefined/null.");
			return;
		}else{
			if(osr.get(0)){
				osr.get(0).destroy();
			}
		}
		let component = this.resolveComponent(this.menuService.currentNode.getScreenTemplate());
		if(component === null){
			this.debug("Aborting. Component is null.");
			return;
		}
		const factory = this.cfr.resolveComponentFactory(component);
		this.debug("##### creating ref for "+this.menuService.getCurrentNode().getScreenTemplate());

		const ref = osr.createComponent(factory);
		this.debug("detecting changes.");
		ref.changeDetectorRef.detectChanges();
		this.muted = false;
	}
	reload(){
		console.log("Reloading panel.");
		let osr = this.content;
		if(osr){

			if(osr.get(0)){
				osr.get(0).destroy();
			}
			let component = this.resolveComponent(this.menuService.getCurrentNode().getScreenTemplate());
			if(component === null){
				return;
			}

			const factory = this.cfr.resolveComponentFactory(component);
			this.debug("##### creating ref for "+this.menuService.getCurrentNode().getScreenTemplate());

			const ref = osr.createComponent(factory);
			this.debug("detecting changes.");
			ref.changeDetectorRef.detectChanges();
		}else{
			console.log("OnScreenReference was null");
		}
		
	}

	ngOnInit(){
		this.debug("onInit");
		this.menuService.reset();
		this.debug("showing dashboard.");

		this.showComponent();
	}
	ngOnDestroy(){
		if(this.subscription){
			this.subscription.unsubscribe();
			this.subscription = undefined;
		}
	}
	ngAfterViewInit() {
		this.debug("NgAfterViewInit()");
	}

	debug(msg:string){
		if(this._debug){
			console.log("ScreenComponent: "+msg);
		}
	}
}
